import { render, staticRenderFns } from "./NuevaIndicacion.vue?vue&type=template&id=359e2bdc&scoped=true"
import script from "./NuevaIndicacion.vue?vue&type=script&lang=js"
export * from "./NuevaIndicacion.vue?vue&type=script&lang=js"
import style0 from "./NuevaIndicacion.vue?vue&type=style&index=0&id=359e2bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e2bdc",
  null
  
)

export default component.exports